import { render, staticRenderFns } from "./TestView.vue?vue&type=template&id=1f00ba17&scoped=true"
import script from "./TestView.vue?vue&type=script&lang=js"
export * from "./TestView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f00ba17",
  null
  
)

export default component.exports